import { useState } from "react";
import { useForm } from "react-hook-form";

import { FormDialog } from "ui/form-dialog";
import CreateFolderForm from "containers/admin/clients/campaign/campaign-creative-page/components/create-folder/create-folder-form/create-folder-form";

import { TouchpointAttributes } from "hooks/api/use-touchpoints";

const CreateFolderModal = ({
  onCloseCallback,
  onConfirmCallback,
  isSubmitting = false,
}: {
  onCloseCallback: () => void;
  onConfirmCallback: (data: { name: string; addedTouchpoints?: TouchpointAttributes[] }) => void;
  isSubmitting: boolean;
}) => {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const form = useForm<{ name: string; addedTouchpoints?: TouchpointAttributes[] }>({
    mode: "onChange",
    shouldUnregister: true,
    defaultValues: { name: "" },
  });

  return (
    <FormDialog
      open
      onClose={onCloseCallback}
      headline="Create folder"
      form={form}
      onSubmit={onConfirmCallback}
      submitDisabled={isSubmitDisabled}
      submitting={isSubmitting}
      submitButtonText="Create folder"
      submitLoadingMessage="Creating folder...">
      <CreateFolderForm setIsSubmitDisabled={setIsSubmitDisabled} />
    </FormDialog>
  );
};

export default CreateFolderModal;
